// src/components/contact/ContactSuccess.jsx
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import Button from '../ui/Button';

const ContactSuccess = () => {
  const location = useLocation();
  const formData = location.state?.formData || {};
  const serviceType = formData.service_type || "your selected service";
  
  return (
    <div className="py-16 bg-gray-50">
      <div className="container mx-auto px-4 text-center">
        <div className="bg-white rounded-lg shadow-md p-8 max-w-2xl mx-auto">
          <div className="h-24 w-24 mx-auto mb-6 bg-green-100 rounded-full flex items-center justify-center">
            <svg className="h-12 w-12 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
            </svg>
          </div>
          
          <h1 className="text-3xl font-bold text-gray-900 mb-4">Message Sent Successfully!</h1>
          
          <p className="text-lg text-gray-600 mb-4">
            Thank you for reaching out to us. We have received your inquiry about {serviceType}.
          </p>
          
          <p className="text-gray-600 mb-8">
            Our team will get back to you as soon as possible at {formData.email || "your email address"}
            {formData.mobile ? ` or ${formData.mobile}` : ""}.
          </p>
          
          <div className="flex flex-col sm:flex-row justify-center gap-4">
            <Link to="/">
              <Button variant="primary">Back to Home</Button>
            </Link>
            <Link to="/portfolio">
              <Button variant="outline">View Our Work</Button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactSuccess;